import { timeAgo, formatDate } from '~/utils/app'

const TimeAgoTag = ({ time }) => {
  return (
    <time dateTime={time} title={formatDate(time)}>
      {timeAgo(time)}
    </time>
  )
}

export default TimeAgoTag
